import React from 'react';
import { Layout, Typography, Button, Space, Avatar } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
// Assuming your logo is in src/assets
import firLogo from '../../assets/fir_logo.png'; // Create this path and add your logo

const { Header } = Layout;
const { Title } = Typography;

const AppHeader: React.FC = () => {
  const { currentUser, signOut } = useAuth(); // FIX: Changed 'user' to 'currentUser'

  const handleLogout = async () => {
    await signOut();
    // Optionally, redirect or show message
  };

  return (
    <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#003A70', padding: '0 24px' }}>
      <Space align="center">
        <img src={firLogo} alt="FIR Logo" style={{ height: '60px', marginRight: '15px' , marginTop: '30px'}} />
        <Title level={3} style={{ color: 'white', margin: 0 }}>PBA – Pfisterer BOM Analyzer</Title>
      </Space>
      {currentUser && ( // FIX: Changed 'user' to 'currentUser'
        <Space>
          <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#87d068' }} />
          <Typography.Text style={{ color: 'white', marginRight: '15px' }}>{currentUser.email}</Typography.Text> {/* FIX: Changed 'user.email' to 'currentUser.email' */}
          <Button type="primary" danger icon={<LogoutOutlined />} onClick={handleLogout}>
            Logout
          </Button>
        </Space>
      )}
    </Header>
  );
};

export default AppHeader;